import React from "react";

export default function Footer() {

    const callApk = (linkData) => {
        window.open(linkData, "_blank");
    };

    return (
        <>
            <hr />
            <br />

            <p className="footer">
                Powered by:
            </p>

            <br />

            <div className="w100 flex center medel wrap">

                <img
                    onClick={() => callApk("https://www.ndsql.top")}
                    className="img_p"
                    src="https://github.com/nahidhk/NdSQL/blob/main/src/assets/img/nav_logo.png?raw=true"
                    alt="NdSQL"
                    style={{ cursor: "pointer" }}
                />

                <img
                    onClick={() => callApk("https://akashbd.net")}
                    className="img_p"
                    src="https://cdnhost.akashbd.net/assets/images/akash-logo-blue.svg?v=10.5.14"
                    alt="Akash"
                    style={{ cursor: "pointer" }}
                />

                <img
                    onClick={() => callApk("https://github.com/iptv-org")}
                    className="img_p"
                    src="https://iptv-org.github.io/apple-touch-icon.png"
                    alt="IPTV Org"
                    style={{ cursor: "pointer" }}
                />

                <img
                    onClick={() => callApk("https://github.com/subirkumarpaul")}
                    className="img_p"
                    src="https://avatars.githubusercontent.com/u/59688232?v=4"
                    alt="NahidHK"
                    style={{ cursor: "pointer" }}
                />

            </div>

            <br />
            <br />

            <p className="footer">
                Released by{" "}
                <a
                    href="https://www.ndsql.top"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    NdSQL
                </a>
                
            </p>

            <br />
            <br />
        </>
    );
}

